import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useSpecificBroker } from "../../dataHooks/brokerQueries";
import { useIsMobileLayout } from "../../../../layout/useIsMobileLayout";
import { MergerChip } from "../../../../components/mergerChip";

export const BrokerMenu: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { pathname } = useLocation();
  const { data: broker } = useSpecificBroker(id);

  // The sign-off page replaces the detail layout rather than opening over it, so the menubar says
  // which one you are on. Same treatment as the counterparty and country menubars. Detected from
  // the path's tail because this is mounted under /brokers and /mergers.
  const onSignOff = /\/signoff\/?$/.test(pathname);

  const name = broker?.brokerName ?? "Broker";
  const isMobile = useIsMobileLayout();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        minWidth: 0
      }}
    >
      <Typography
        variant={isMobile ? "h6" : "h5"}
        component="span"
        noWrap
        sx={{ display: "block", minWidth: 0 }}
      >
        {onSignOff ? `Sign off: ${name}` : name}
      </Typography>
      {broker?.isMerger && <MergerChip size={isMobile ? "small" : "medium"} />}
    </Box>
  );
};
